import PropTypes from 'prop-types';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';
import ModalBodyGiftCardCancel from 'components/molecules/ModalBodyGiftCardCancel/ModalBodyGiftCardCancel';

const ModalGiftCardCancel = props => {
  const { closeModal, sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.GIFT_CARD_CANCEL}
      onClose={closeModal}
      sendPageView={false}
    >
      <ModalBodyGiftCardCancel {...props} />
    </Modal>
  );
};

ModalGiftCardCancel.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
};

export default ModalGiftCardCancel;
